import { AbstractBlock } from '../AbstractBlock';
import { ShapeSettings } from '../setting/ShapeSettings';
import { ColorSettings } from '../setting/ColorSettings';
import { CodeSetting } from '../setting/CodeSetting';
import { GlobalImport } from '../../utils/GlobalImport';
import { BlockType } from '../../@types/BlockType';
import { block_translation } from '../../lang/BlockTranslation';
const Blockly = GlobalImport.getBlockly();

const t = block_translation;
export class EntityElement extends AbstractBlock {
  constructor() {
    super('entity_element', t.to('グループ', 'group'));
  }

  defineBlock(block: BlockType): void {
    ShapeSettings.setElementWithSubBlockShape(block);
    ColorSettings.setObjectColor(block);
    ShapeSettings.setTitleField(block, t.to('グループ', 'group'));

    // const name = new Blockly.FieldTextInput('');
    // block.appendDummyInput().appendField(`<`).appendField(name, 'name').appendField(`>`);

    ShapeSettings.addAttributeInput(block);
    ShapeSettings.addStatementInput(block);
  }

  codeGenerateCore(block: BlockType): string {
    const attribute = CodeSetting.getSubAttributeCode(block);
    const sub = CodeSetting.getSubstatementCode(block);
    const str = CodeSetting.getElementCode('a-entity', attribute, block.id, sub);

    return str;
  }
}
